import { AxiosInstance } from 'axios';
import { BaseApi } from 'services/api/base-api';
import { ApiResult } from 'services/api/result.type';

export interface SamlConfig {
  id?: string;
  entityId: string;
  singleSignOnUrl: string;
  x509Certificate: string;
  isActive: boolean;
}

export interface SamlSchoolInfo {
  success: boolean;
  redirectUrl?: string;
}

export class SamlApi extends BaseApi {
  public constructor(protected readonly api: AxiosInstance) {
    super();

    this.getProvider = this.getProvider.bind(this);
    this.createProvider = this.createProvider.bind(this);
    this.updateProvider = this.updateProvider.bind(this);
    this.deleteProvider = this.deleteProvider.bind(this);
    this.getSamlSchoolForEmail = this.getSamlSchoolForEmail.bind(this);
  }

  public async getProvider(schoolId: string): ApiResult<SamlConfig> {
    return await this.get<SamlConfig>(`/saml-provider/${schoolId}`);
  }

  public async createProvider(
    schoolId: string,
    config: Omit<SamlConfig, 'id'>,
  ): ApiResult<SamlConfig> {
    return await this.post<SamlConfig>(`/saml-provider/${schoolId}`, config);
  }

  public async updateProvider(
    schoolId: string,
    config: Partial<SamlConfig>,
  ): ApiResult<SamlConfig> {
    return await this.put<SamlConfig>(`/saml-provider/${schoolId}`, config);
  }

  public async deleteProvider(schoolId: string): ApiResult<void> {
    return await this.delete<void>(`/saml-provider/${schoolId}`);
  }

  public async getSamlSchoolForEmail(
    email: string,
  ): ApiResult<SamlSchoolInfo | null> {
    return await this.get<SamlSchoolInfo | null>('/saml/school-for-email', {
      params: { email },
    });
  }
}
